import ErrorDialog from './packages/dialogs/Error_index.js';
import CompleteDialog from './packages/dialogs/Complete_index.js';

const components = [
  ErrorDialog,
  CompleteDialog
]

const install = function(Vue, opts = {}) {
  components.map(component => {
    Vue.component(component.name, component);
  })
}

/* 支持使用标签的方式引入 */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  ErrorDialog
}


// WEBPACK FOOTER //
// ./src/index.js